//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ChangeColMixin } from '@/mixins/ChangeColMixin1';
import { downloadFile } from '@/api/manage';
import colControl from '@/components/colControl/colControl';
import { getTenantStByToken } from '@/api/api';
import moment from 'moment';
export default {
  name: 'waterData',
  data: function data() {
    return {
      stList: [],
      st: '',
      ipagination: false,
      isPagination: false,
      interTimer: null
    };
  },
  watch: {
    st: {
      handler: function handler(val) {
        this.queryParam.st = val;
      },
      deep: true
    }
  },
  mixins: [ChangeColMixin],
  components: {
    colControl: colControl
  },
  created: function created() {
    this.getTenantStList();
  },
  destroyed: function destroyed() {
    clearInterval(this.interTimer);
  },
  methods: {
    getTenantStList: function getTenantStList() {
      var _this = this;

      this.stList = [];
      getTenantStByToken().then(function (res) {
        if (res.success) {
          _this.stList = res.result;
          _this.queryParam.st = _this.stList[0].value;
          _this.st = _this.stList[0].value;
          _this.queryParam.current = 1;
          _this.queryParam.size = 1000000000;

          _this.getCol(_this.stList[0].value);

          _this.$forceUpdate();

          _this.url = '/online/st' + _this.queryParam.st + '/realtime';
          clearInterval(_this.interTimer);

          _this.loadData();

          setTimeout(function () {
            if (_this.dataSource.length > 12) {
              _this.interTimer = setInterval(function () {
                var timer = setTimeout(function () {
                  _this.dataSource.push(_this.dataSource[0]);

                  _this.dataSource.shift();

                  clearTimeout(timer);
                }, 1000);
              }, 1000);
            }
          }, 1500);
        }
      });
    },
    // 类型字典变化
    typeChange: function typeChange(val) {
      var _this2 = this;

      this.queryParam.st = val;
      this.$forceUpdate();
      this.queryParam.current = 1;
      this.queryParam.size = 1000000000;
      this.url = '/online/st' + this.queryParam.st + '/realtime';
      this.getCol(val);
      clearInterval(this.interTimer);
      this.loadData();
      setTimeout(function () {
        if (_this2.dataSource.length > 12) {
          _this2.interTimer = setInterval(function () {
            var timer = setTimeout(function () {
              _this2.dataSource.push(_this2.dataSource[0]);

              _this2.dataSource.shift();

              clearTimeout(timer);
            }, 1000);
          }, 1000);
        }
      }, 1500);
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};